import { render, staticRenderFns } from "./CardCobrancas.vue?vue&type=template&id=3190833e&"
import script from "./CardCobrancas.vue?vue&type=script&lang=js&"
export * from "./CardCobrancas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports